import { cn } from '@/lib/utils';
import { TableHead } from '@startupquickstart/frontend';
import { ChevronDown, ChevronsUpDown, ChevronUp } from 'lucide-react';

interface SortableTableHeadProps<K extends string> {
  label: string;
  /** The sort key this column maps to in the table's accessors. */
  sortKey: K;
  /** The currently active sort key. */
  activeKey: K;
  direction: 'asc' | 'desc';
  onSort: (key: K) => void;
  className?: string;
}

/**
 * A `TableHead` whose label is a sort toggle, with an up/down chevron when
 * active and a neutral chevron otherwise — matching the sortable columns on the
 * hotel CRUD lists.
 */
export function SortableTableHead<K extends string>({
  label,
  sortKey,
  activeKey,
  direction,
  onSort,
  className,
}: SortableTableHeadProps<K>) {
  const active = activeKey === sortKey;
  return (
    <TableHead className={className}>
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className={cn(
          'inline-flex items-center gap-1 transition-colors hover:text-foreground',
          active ? 'text-foreground' : 'text-muted-foreground',
        )}
        aria-label={`Sort by ${label}`}
      >
        {label}
        {active ? (
          direction === 'asc' ? (
            <ChevronUp className="h-3.5 w-3.5" />
          ) : (
            <ChevronDown className="h-3.5 w-3.5" />
          )
        ) : (
          <ChevronsUpDown className="h-3.5 w-3.5 opacity-50" />
        )}
      </button>
    </TableHead>
  );
}
